import { ConfigProvider } from "antd";
import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";

import MainApp from "./MainApp";
import { useApp } from "./index.hook";
import Authentication from "../../util/Authentication";
import { RouteConstants } from "../../constants/ApplicationConstants/RouteConstants";

/* Component which ensures to scroll to top of the page as soon as route is changed. */
const ScrollToTop = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();

  useEffect(() => {
    const element = document.querySelector(".ant-layout-content");
    if (!element) return;

    element.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname, location.search]);

  return <>{children}</>;
};

const App = ({ children }: { children: React.ReactNode }) => {
  const { currentAppLocale, isDirectionRTL } = useApp();

  /* Check if required localStorage keys exist; if not, redirect to ROOT_PAGE */
  const isUserSessionActive = Authentication.isUserSessionActive();
  if (!isUserSessionActive) return <Navigate to={RouteConstants.ROOT_PAGE} />;

  return (
    <ConfigProvider locale={currentAppLocale.antd} direction={isDirectionRTL ? "rtl" : "ltr"}>
      <ScrollToTop>
        <MainApp>{children}</MainApp>
      </ScrollToTop>
    </ConfigProvider>
  );
};

export default App;
